import React, { useState } from "react"


const VersionHeader = () => {

    return (
        <div class="header-section userside-page">
            <div class="container-fluid">
               
                <div className="logo m-auto">
                    <div className="header-text">
                        <span className="tekacolor">TEKa</span>
                        <span className="custom-color">Help</span>
                    </div>
                </div>
               
            </div>
        </div>)
}
export default VersionHeader
